import i18n from '@dinosband/bv-i18n'
import { types } from '../../types'
import { makeBackwardCompatible } from '../utils'

//----------------------------------------------
// C: Client, P: Provider
//----------------------------------------------
// [Start:모집 중] => Apply(P)
// => [Open:협의 중] => Ask-Hire(P), Hire(C)
// => [Hired:업무 진행 중] => Ask-Finish(P), Finish(C)
// => [WorkFinished:리뷰 중] => Review (C & P)
// => [Closed:완료됨]
//----------------------------------------------

export function getJobMatchingProcess (): types.ChatRoomProcess {
  return makeBackwardCompatible({
    type: 'job-matching',
    states: [
      {
        id: 'Start',
        name: i18n.tc('message.recruiting'),
      },
      {
        id: 'Open',
        name: i18n.tc('message.negotiating'),
      },
      {
        id: 'Hired',
        name: i18n.tc('process.wip'),
      },
      {
        id: 'WorkFinished',
        name: i18n.tc('message.reviewing'),
      },
      {
        id: 'Closed',
        name: i18n.tc('message.completed'),
      },
    ],
    clientActions: [
      {
        id: 'Hire',
        name: i18n.tc('process.hire'),
        from: 'Open',
        to: 'Hired',
      },
      {
        id: 'Finish',
        name: i18n.tc('process.jobFinish'),
        from: 'Hired',
        to: 'WorkFinished',
      },
      {
        id: 'Cancel',
        name: i18n.tc('process.hireCancel'),
        from: 'Hired',
        to: 'Canceled',
      },
      {
        id: 'Review',
        name: i18n.tc('message.review'),
        from: 'WorkFinished',
        to: 'Closed',
      },
    ],
    providerActions: [
      {
        id: 'Apply',
        name: i18n.tc('message.apply'),
        from: 'Start',
        to: 'Open',
      },
      {
        id: 'Ask-hire',
        name: i18n.tc('process.hireRequest'),
        from: 'Open',
        to: 'Open',
      },
      {
        id: 'Ask-finish',
        name: i18n.tc('process.jobFinishRequest'),
        from: 'Hired',
        to: 'Hired',
      },
      {
        id: 'Review',
        name: i18n.tc('message.review'),
        from: 'WorkFinished',
        to: 'Closed',
      },
    ],
  })
}
